import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { amountToLong } from '../../../../utils/amountToLong';
import { type WidgetProps } from '../../../../types/WidgetProps';
import { type BiLogger } from '../../../Provider/BiLogger/BiLogger';
import { logGeneralError } from '../../../../utils/sentry';
import {
  fastCheckoutButtonClicked,
  spbButtonStartInitializationCheckout,
  spbButtonSuccessInitializationCheckout,
  spbErrorDuringValidationFromVertical,
} from '../../../../utils/bi/events/biEvents';

type CreateOnShippingContactSelectedParams = {
  topProps: WidgetProps;
  biLogger: BiLogger;
};

export const createOnClick =
  ({ topProps, biLogger }: CreateOnShippingContactSelectedParams) =>
  async (e: Event) => {
    const { paymentAmount, currency, meta, demoMode } = topProps;

    if (demoMode) {
      // Prevent display of the payment sheet
      e.preventDefault();
      topProps.onClick();
      return;
    }

    biLogger.report(fastCheckoutButtonClicked, {
      amount: amountToLong(paymentAmount),
      cartId: meta.cartId,
      productid: meta.productId,
      currency,
      paymentProvider: PaymentProvider.WixPayUS,
      paymentmethod: PaymentMethod.GooglePay,
      isPartner: undefined as any, // TODO[bi]
      orderSnapshotId: undefined as any, // TODO[bi]
      transactionId: undefined as any, // TODO[bi]
      // @ts-expect-error default value override
      appId: meta.appDefId,
    });

    try {
      // Validate possibility to pay by vertical
      const { canceled } = topProps.onClick() as { canceled: boolean };

      if (canceled) {
        biLogger.report(spbErrorDuringValidationFromVertical, {
          cartId: meta.cartId,
          productId: meta.productId,
          amount: amountToLong(paymentAmount),
          currency,
          paymentProvider: PaymentProvider.WixPayUS,
          paymentmethod: PaymentMethod.GooglePay,
          isPartner: undefined as any, // TODO[bi]
          orderSnapshotId: undefined as any, // TODO[bi]
          transactionId: undefined as any, // TODO[bi]
          errorReason: undefined as any, // TODO[bi]
        });
        // Prevent display of the payment sheet
        e.preventDefault();
        return;
      }

      biLogger.report(spbButtonStartInitializationCheckout, {
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.GooglePay,
        currency: undefined as any, // TODO[bi]
        cartId: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
      });

      // Fix BI events mess. In case of digital product google don't trigger onPaymentDataChanged "INITIALIZE" event - https://wix.atlassian.net/browse/PAY-26743
      if (!topProps.requestShipping) {
        biLogger.report(spbButtonSuccessInitializationCheckout, {
          paymentProvider: PaymentProvider.WixPayUS,
          paymentmethod: PaymentMethod.GooglePay,
          // @ts-expect-error default value override
          requestShipping: topProps.requestShipping,
        });
      }
    } catch (error) {
      e.preventDefault();

      logGeneralError({
        payload: {
          plainError: JSON.stringify(e),
        },
        message: '[GooglePay] props.onClick() throws exception',
        fingerprint: ['googlePay', 'onClick'],
      });
    }
  };
